module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remote"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('remote.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('linkManage.title')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('remote.crumbs.L3')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('remote.panel.title')))]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('remote.panel.shareGuide')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "add-form",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    staticClass: "addform-close-icon",
    attrs: {
      "label": _vm.$t('remote.form.productName'),
      "prop": "goods_name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.addForm.goods_name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "goods_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addForm.goods_name"
    }
  }), _vm._v(" "), (_vm.addForm.goods_name !== '') ? _c('i', {
    staticClass: "el-input__icon el-icon-close",
    on: {
      "click": function($event) {
        _vm.addForm.goods_name = ''
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fe_quantity",
    attrs: {
      "label": _vm.$t('remote.form.quantity'),
      "prop": "quantity"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 5
    },
    model: {
      value: (_vm.addForm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "quantity", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addForm.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fe_el-select",
    attrs: {
      "label": _vm.$t('remote.form.currency')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.currency),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "currency", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addForm.currency"
    }
  }, _vm._l((_vm.currencyList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "addform-close-icon fe_unit-price",
    attrs: {
      "label": _vm.$t('remote.form.price'),
      "prop": "unit_price"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 13
    },
    model: {
      value: (_vm.addForm.unit_price),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "unit_price", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addForm.unit_price"
    }
  }), _vm._v(" "), (_vm.addForm.unit_price !== '') ? _c('i', {
    staticClass: "el-input__icon el-icon-close",
    on: {
      "click": function($event) {
        _vm.addForm.unit_price = ''
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": _vm.goods_info.length >= 10
    },
    on: {
      "click": function($event) {
        return _vm.addRemoteForm('addForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('remote.form.add')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "add-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goods_info,
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "goods_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "reduce",
          on: {
            "click": function($event) {
              return _vm.reduceQuantity(scope)
            }
          }
        }, [_vm._v("-")]), _vm._v(" "), _c('span', {
          staticClass: "table-quantity"
        }, [_vm._v(_vm._s(scope.row.quantity))]), _vm._v(" "), _c('button', {
          staticClass: "increase",
          on: {
            "click": function($event) {
              return _vm.increaseQuantity(scope)
            }
          }
        }, [_vm._v("+")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "currency"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.currencyList1[scope.row.currency]) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit_price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "delete"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('remote.form.delete')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "remoteForm",
    staticClass: "remote-form",
    attrs: {
      "model": _vm.remoteForm,
      "rules": _vm.remoteFormRules,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "close-icon",
    attrs: {
      "label": _vm.$t('remote.form.totalAmount')
    }
  }, [_c('el-select', {
    staticClass: "total-amount",
    model: {
      value: (_vm.remoteForm.totalCurrency),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "totalCurrency", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.totalCurrency"
    }
  }, _vm._l((_vm.currencyList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sing-validte",
    attrs: {
      "prop": "totalAmount"
    }
  }, [_c('el-input', {
    staticClass: "inputtotal-amount",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.remoteForm.totalAmount),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "totalAmount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.totalAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "close-icon",
    attrs: {
      "label": _vm.$t('remote.form.customerName'),
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": _vm.$t('remote.form.customerName')
    },
    model: {
      value: (_vm.remoteForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "customerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.customerName"
    }
  }), _vm._v(" "), (_vm.remoteForm.customerName !== '') ? _c('i', {
    staticClass: "el-input__icon el-icon-close",
    on: {
      "click": function($event) {
        _vm.remoteForm.customerName = ''
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "close-icon",
    attrs: {
      "label": _vm.$t('remote.form.customerPhone')
    }
  }, [_c('el-form-item', {
    staticClass: "sing-validte",
    attrs: {
      "prop": "customerPhoneRegion"
    }
  }, [_c('el-input', {
    staticClass: "region-phone_left",
    class: {
      'phone-status': _vm.phoneStatus
    },
    attrs: {
      "maxlength": 3
    },
    on: {
      "blur": _vm.getphoneStatus
    },
    model: {
      value: (_vm.remoteForm.customerPhoneRegion),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "customerPhoneRegion", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.customerPhoneRegion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sing-validte",
    attrs: {
      "prop": "customerPhone"
    }
  }, [_c('el-input', {
    staticClass: "region-phone_right",
    class: {
      'phone-status': _vm.phoneStatus
    },
    attrs: {
      "placeholder": _vm.$t('remote.form.customerPhone'),
      "maxlength": 20
    },
    on: {
      "blur": _vm.getphoneStatus
    },
    model: {
      value: (_vm.remoteForm.customerPhone),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "customerPhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.customerPhone"
    }
  })], 1), _vm._v(" "), (_vm.remoteForm.customerPhone !== '' || _vm.remoteForm.customerPhoneRegion !== '') ? _c('i', {
    staticClass: "el-input__icon el-icon-close coustomer_phone_icon",
    on: {
      "click": _vm.clearContent
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "phone_font"
  }, [_vm._v(_vm._s(_vm.$t('remote.form.phone_font')))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "close-icon",
    attrs: {
      "label": _vm.$t('remote.form.customerEmail'),
      "prop": "customerEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": _vm.$t('remote.form.customerEmail')
    },
    model: {
      value: (_vm.remoteForm.customerEmail),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "customerEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.customerEmail"
    }
  }), _vm._v(" "), (_vm.remoteForm.customerEmail !== '') ? _c('i', {
    staticClass: "el-input__icon el-icon-close",
    on: {
      "click": function($event) {
        _vm.remoteForm.customerEmail = ''
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('remote.form.paymentDeadline')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "clearable": false,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.remoteForm.paymentDeadline),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "paymentDeadline", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.paymentDeadline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('remote.form.logisticsMode.title')
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: (_vm.remoteForm.logisticsMode),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "logisticsMode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.logisticsMode"
    }
  }, _vm._l((_vm.logisticsModeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('remote.form.date')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "clearable": false,
      "disabled": _vm.dateStatus,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.remoteForm.date),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "date", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "count-number",
    attrs: {
      "label": _vm.$t('remote.form.description'),
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 6,
      "type": "textarea",
      "maxlength": 500,
      "placeholder": _vm.$t('remote.form.writeDescription')
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.getCount($event)
      }
    },
    model: {
      value: (_vm.remoteForm.description),
      callback: function($$v) {
        _vm.$set(_vm.remoteForm, "description", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "remoteForm.description"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.count) + "/500")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "underline"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside",
      "autoplay": false,
      "arrow": "never",
      "trigger": "click"
    }
  }, _vm._l((_vm.swipperImages), function(item, $index) {
    return _c('el-carousel-item', {
      key: $index
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('a', {
    on: {
      "click": _vm.returnToLinkList
    }
  }, [_vm._v(_vm._s(_vm.$t('remote.btn.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "remote-link",
    attrs: {
      "disabled": _vm.btnStatus
    },
    on: {
      "click": function($event) {
        return _vm.getRmotePayLink('remoteForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('remote.btn.link')))])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f35f7e24"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/remotePay/remotePay.vue
// module id = 935
// module chunks = 0